<template>
  <table-card :in-tab="true"
              title="Completed tag scans"
              :fields="fields"
              :items="list">
    <template slot="header">
      <b-btn-group class="date-cursor">
        <b-btn @click="navigate(-1)"
               variant="light" class="px-2 border-border">
          <i class="fas fa-arrow-left"/>
        </b-btn>
        <b-btn variant="light" class="bg-white border-border">
          {{ selectedDate }}
        </b-btn>
        <b-btn @click="navigate(1)"
               :disabled="endOfDate" variant="light" class="px-2 border-border">
          <i class="fas fa-arrow-right"/>
        </b-btn>
      </b-btn-group>
    </template>
    <template v-slot:cell(clean)="data">
      <b-badge v-if="data.value" variant="success">
        <i class="fas fa-smile" />
      </b-badge>
      <b-badge v-if="!data.value" variant="danger">
        <i class="fas fa-bug" />
      </b-badge>
    </template>
    <template v-slot:row-details="row">
      <div class="p-5">
        <b-alert :show="!row.item.clean" variant="danger">
          {{ row.item.example + row.item.comment }}
        </b-alert>
        <b-form-textarea :rows="5" :value="row.item.adm" />
        <div class="m-5 p-3 border-radius border">
          <iframe width="600" height="300" scrolling="no" frameborder="none" :srcdoc="row.item.adm" />
        </div>
      </div>
    </template>
  </table-card>
</template>

<script>
    import auth from '@/auth'
    import {DemandApi} from "../../api"
    import TableCard from "../../../components/TableCard"

    export default {
        name: 'ScanCompleted',
        props: {
            cid: { required: false }
        },
        created() {
            this.update()
        },
        data() {
            return {
                fields: [
                    { key: 'company' },
                    { key: 'company_id' },
                    { key: 'cid', label: 'Campaign Id' },
                    { key: 'crid', label: 'Creative Id' },
                    { key: 'type', label: 'Flag Reason'},
                    { key: 'clean', label: 'Clean'}
                ],
                start: moment().startOf('day').valueOf(),
                list: []
            }
        },
        computed: {
            end() {
                return moment(this.start).endOf('day').valueOf()
            },
            endOfDate() {
                return moment(this.start).isSame(moment().tz('utc'), 'day')
            },
            selectedDate() {
                return moment(this.start).format('MMM Do')
            }
        },
        methods: {
            update() {
                DemandApi.scanCompletedList(this.start.valueOf(), this.end, this.cid)
                    .then(list => this.list = list)
                    .catch((e) => this.$notify.error('Failed to list scans'))
            },
            navigate(offset) {
                this.start = moment(this.start).add(offset, 'days').valueOf()
                this.update()
            }
        },
        components: {
            TableCard
        }
    }
</script>

<style>
  .date-cursor {
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/demand/pages/components/ScanCompleted.vue